import { Component } from "react";
import { defaultCard } from "./cardDefault";
import { twitterStatus, twitterCard } from "./cardTwitter";
import { googleMapsUrlRegex, GoogleMapsCard } from "./cardGoogleMaps";

class Card extends Component {
	render() {
		const { href, data } = this.props;

		if (data && href.match(twitterStatus)) {
			return twitterCard(this.props);
		} else if (href.match(googleMapsUrlRegex)) {
			return GoogleMapsCard(this.props);
		} else {
			return defaultCard(this.props);
		}
	}
}

export default Card;



// WEBPACK FOOTER //
// ./src/components/ui/card/card.js